/**
 * Project : workspace
 * File    : EmptyData.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package component.empty

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.Refresh
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.core.app.AppViewModel
import locale.localization
import theme.ThemeColor

@Composable
/**
 * Executes the empty data operation.
 *
 * @receiver TODO
 * @param name The name.
 * @param viewModel The view model.
 * @param onClickRetry The on click retry.
 * @return Unit – no return value.
 */
fun EmptyData(name: String = "", viewModel: AppViewModel?, onClickRetry: () -> Unit = {}) {
    val isLoading = viewModel?.isLoading?.collectAsState()
    if (isLoading?.value != null && !isLoading.value) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .height(400.dp),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = localization().employee.employeeAlertTitleMessage,
                Modifier
                    .padding(start = 30.dp, end = 30.dp, bottom = 30.dp),
                fontSize = 20.sp,
                lineHeight = 30.sp,
                color = ThemeColor.shared().gray
            )
            Icon(
                Icons.Rounded.Refresh,
                contentDescription = "Reload",
                modifier = Modifier
                    .size(60.dp)
                    .clickable { onClickRetry() })
        }
    }

}